<template>
  <v-card class="mb-12 mx-4" elevation="0">
    <v-row>
      <v-col md="6" cols="12" v-for="(item, index) in allSteps" :key="index">
        <v-btn block depressed outlined class="rounded-lg d-flex px-4" height="48" style="border-color: #8D9DC7"
          @click="openAddAction(item, index)">
          <div class="d-flex align-center justify-space-between w-100">
            <p class="mb-0 thirdColor--text sm-font300-12">{{ item.title }}</p>
            <v-icon size="20" color="thirdColor">
              {{ item.session_count > 0 ? 'mdi-pen' : 'mdi-plus-circle-outline' }}
            </v-icon>
          </div>
        </v-btn>
      </v-col>
      <v-col cols="12" class="d-flex justify-end">
        <v-btn @click="cancelProcess" color="positive" class="textColor--text sm-font500-16 rounded-xl me-3" depressed height="48" width="230">
          ثبت
        </v-btn>

        <v-btn width="230" height="48" depressed color="nagative" class="textColor--text sm-font500-16 rounded-xl"
          @click="cancelProcess">
          انصراف
        </v-btn>
      </v-col>


      <v-dialog v-model="planDataModal" width="850">
        <v-card class="pa-10 rounded-xl">
          <div class="d-flex mb-7">
            <p class="mb-0 sm-font600-16 textColorSecond--text">برای برنامه {{currentPlan?.title}} حرکت تعریف کنید</p>
          </div>

          <v-row>
            <template v-if="actionList.length > 0">
              <v-col cols="12" v-for="(item, index) in actionList" :key="index">
                <div>
                  <label>نوع دوره</label>
                  <v-select clearable :items="lessonType" class="rounded-lg mt-2 sm-font400-14 mb-4" item-text="text"
                            item-value="value" hide-details solo v-model="item.session_type"></v-select>
                </div>
                <div>
                  <label>عنوان حرکت</label>
                  <v-text-field v-if="item.session_type" v-model="item.title" class="rounded-lg pr-0 sm-font400-14" solo append-icon="mdi-delete"
                                single-line height="48" hide-details></v-text-field>
                </div>
                <v-row class="mt-1" v-if="item.session_type === 'Offline'">
                  <v-col :md="6">
                    <label>تعداد حرکت</label>
                    <v-text-field v-model="item.description" class="rounded-lg pr-0 sm-font400-14 me-6 mt-2" solo
                                  single-line height="48" hide-details></v-text-field>
                  </v-col>
                  <v-col :md="6">
                    <label>ویدیو حرکت</label>
                    <v-text-field v-model="item.video_link" class="rounded-lg pr-0 sm-font400-14 mt-2" solo
                                  single-line height="48" hide-details></v-text-field>
                  </v-col>
                  <!-- <v-file-input v-model="item.actionVideo" prepend-icon="" append-icon="mdi-upload"
                    placeholder="ویدیو حرکت" hide-details height="48" class="rounded-lg mt-2 sm-font400-14"
                    solo></v-file-input> -->
                </v-row>
                <v-divider class="mt-8" />
              </v-col>
            </template>
            <v-col cols="12">
              <v-btn color="thirdColor" class="textColor--text sm-font500-16 rounded-xl me-3" depressed height="48"
                @click="actionList.push({})">
                <div class="d-flex align-center justify-space-between w-100">
                  <p class="mb-0">افزودن</p>
                  <v-icon size="20">mdi-plus</v-icon>
                </div>
              </v-btn>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn color="positive" class="textColor--text sm-font500-16 rounded-xl me-3" depressed height="48"
                width="230" @click="addActionToPlan">
                ثبت
              </v-btn>

              <v-btn width="230" height="48" depressed color="nagative" class="textColor--text sm-font500-16 rounded-xl"
                @click="planDataModal = false">
                انصراف
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>
<script>
import courseApi from "@/Services/modules/courses"
export default {
  name: "actions",
  data() {
    return {
      planDataModal: false,
      lessonType: [{ id: 0, value: "Online", text: "آنلاین" }, { id: 1, value: "Offline", text: "آفلاین" }],
      allSteps: [],
      actionList: [],
      currentPlan: null
    }
  },
  methods: {
    getData() {
      let data = {
        course: this.$route.params.id
      }
      courseApi.getLessons(data).then(res => {
        this.allSteps = res.data.results
      })
    },
    openAddAction(item) {
      this.currentPlan = item
      courseApi.getSessions({ lesson: item.id }).then((res) => {
        this.planDataModal = true
        this.actionList = res.data.results
      })
    },
    addActionToPlan() {
      this.actionList.map((item, index) => {
        if (item.id) {
          courseApi.patchSessions({...item , lesson: this.currentPlan.id}).then(() => {
            if (index === this.actionList.length - 1) {
              this.getData()
              this.planDataModal = false
            }
          })
        } else {
          courseApi.postSessions({ ...item, lesson: this.currentPlan.id }).then(() => {
            if (index === this.actionList.length - 1) {
              this.getData()
              this.planDataModal = false
            }
          })
        }
      })
    },
    cancelProcess() {
      this.$router.push('/courses/course-list')
    },
  },
  mounted() {
    this.getData()
  }
}
</script>
<style scoped></style>